import * as React from 'react';
import { Input } from '@/components/ui/input';
import type { NumberLiteralDataType } from '@glueapp/graph-types';

interface ShapeNumberLiteralEditorProps {
    value: NumberLiteralDataType;
    onChange: (value: NumberLiteralDataType) => void;
}

export const ShapeNumberLiteralEditor: React.FC<ShapeNumberLiteralEditorProps> = ({ value, onChange }) => {
    return (
        <div className="flex flex-col gap-1.5 pt-1">
            <label className="text-xs font-medium text-muted-foreground">Number value</label>
            <Input
                type="number"
                value={value.numberLiteral}
                onChange={e => onChange({ kind: 'numberLiteral', numberLiteral: parseFloat(e.target.value) })}
            />
        </div>
    );
};
